import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=12a30465&scoped=true&lang=html&"
import script from "./statisticsData.vue?vue&type=script&lang=js&"
export * from "./statisticsData.vue?vue&type=script&lang=js&"
import style0 from "./statisticsData.vue?vue&type=style&index=0&id=12a30465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a30465",
  null
  
)

component.options.__file = "statisticsData.vue"
export default component.exports